var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as AuthLib from './auth';
/**
 * Clear temporary OAuth state that can make Amplify password sign-in wait forever.
 *
 * Reaching this direct-login page means any managed-login redirect was abandoned.
 * Authentication tokens and remembered-user keys are intentionally preserved.
 *
 * Known Amplify v6 bug: https://github.com/aws-amplify/amplify-js/issues/14900
 */
function clearPendingOAuthState() {
    var clientId = process.env.AWS_COGNITO_WEB_AGENT_CLIENT_ID;
    if (!clientId) {
        return;
    }
    var storageKeyPrefix = "CognitoIdentityServiceProvider.".concat(clientId);
    try {
        localStorage.removeItem("".concat(storageKeyPrefix, ".inflightOAuth"));
        localStorage.removeItem("".concat(storageKeyPrefix, ".oauthPKCE"));
        localStorage.removeItem("".concat(storageKeyPrefix, ".oauthState"));
    }
    catch (error) {
        console.warn('Unable to clear pending OAuth state.', error);
    }
}
export function clearAlerts() {
    document.getElementById('successAlert').style.display = 'none';
    document.getElementById('errorAlert').style.display = 'none';
    document.getElementById('infoAlert').style.display = 'none';
}
export function showSuccessAlert(message) {
    clearAlerts();
    document.getElementById('successAlert').style.display = 'block';
    document.getElementById('errorAlert').style.display = 'none';
    document.getElementById('infoAlert').style.display = 'none';
    document.getElementById('successMessage').innerHTML = message;
}
export function showErrorAlert(error) {
    clearAlerts();
    enableForm(true);
    console.log('Error object:', JSON.stringify(error), error.message);
    if (error.name === 'NotAuthorizedException') {
        if (error.message === 'Incorrect username or password.') {
            error.message = 'Incorrect agent code or password.';
        }
        else if (error.message === 'Invalid session for the user, session is expired.') {
            error.message = 'Authentication code has expired. <a href="javascript:login.signIn(event)">Please request another code</a>.';
        }
        else if (error.message === 'User is disabled.') { // User is locked.
            error.message = 'This account has been locked or terminated due to inactivity. Please contact <a href="mailto:info@syncis.com">info@syncis.com</a> for support.';
        }
    }
    if (error.name === 'CodeMismatchException') {
        error.message = 'Invalid authentication code.';
    }
    if (error.name === 'LimitExceededException') {
        // No need to override the default error message.
    }
    if (error.name === 'InvalidParameterException') {
        error.message = 'Incorrect agent code or password.';
    }
    var errorMessageToDisplay = error.message;
    errorMessageToDisplay = errorMessageToDisplay.replace('username', 'agent code');
    errorMessageToDisplay = errorMessageToDisplay.replace('PreAuthentication failed with error', '');
    document.getElementById('successAlert').style.display = 'none';
    document.getElementById('errorAlert').style.display = 'block';
    document.getElementById('infoAlert').style.display = 'none';
    document.getElementById('errorMessage').innerHTML = errorMessageToDisplay;
}
export function showInfoAlert(message) {
    clearAlerts();
    document.getElementById('successAlert').style.display = 'none';
    document.getElementById('errorAlert').style.display = 'none';
    document.getElementById('infoAlert').style.display = 'block';
    document.getElementById('infoMessage').innerHTML = message;
}
export function enableForm(enabled) {
    var forms = document.forms;
    for (var formIndex = 0; formIndex < forms.length; formIndex++) {
        var form = forms[formIndex];
        var elements = form.elements;
        var i = 0, len = elements.length;
        for (; i < len; ++i) {
            // (elements[i] as HTMLInputElement).readOnly = !enabled;
            // (elements[i] as HTMLInputElement).readOnly = enabled;
            if (enabled) {
                elements[i].disabled = false;
            }
            else {
                elements[i].disabled = true;
            }
        }
    }
}
export function showForm(formName, label) {
    if (label === void 0) { label = null; }
    enableForm(true);
    document.getElementById("loginForm").style.display = "none";
    document.getElementById("returnForm").style.display = "none";
    document.getElementById("mfaForm").style.display = "none";
    document.getElementById("mfaSelectForm").style.display = "none";
    document.getElementById("mfaSetupForm").style.display = "none";
    if (formName === 'returnForm') {
        document.getElementById("returnForm").style.display = "inline";
    }
    if (formName === 'loginForm') {
        clearAlerts();
        document.getElementById("input_username").value = '';
        document.getElementById("input_password").value = '';
        document.getElementById("loginForm").style.display = "inline";
        document.getElementById("input_username").focus();
    }
    if (formName === 'mfaForm') {
        clearAlerts();
        document.getElementById('label_input_mfa_code').innerHTML = label;
        document.getElementById("mfaForm").style.display = "inline";
        document.getElementById('input_mfa_code').value = '';
        document.getElementById("input_mfa_code").focus();
    }
    if (formName === 'mfaSetupForm') {
        clearAlerts();
        document.getElementById('label_input_email').innerHTML = label;
        document.getElementById("mfaSetupForm").style.display = "inline";
        document.getElementById("input_email").value = '';
        document.getElementById("input_email").focus();
    }
    if (formName === 'mfaSelectForm') {
        clearAlerts();
        document.getElementById('label_mfa_select').innerHTML = label;
        document.getElementById("mfaSelectForm").style.display = "inline";
        document.getElementById("method-sms").checked = false;
        document.getElementById("method-email").checked = false;
    }
}
export function postToLoginAmplify(path) {
    return __awaiter(this, void 0, void 0, function () {
        var signedInUser, form, params, key, hiddenField;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AuthLib.getSignedInUser()];
                case 1:
                    signedInUser = _a.sent();
                    form = document.createElement("form");
                    // Move the submit function to another variable so that it doesn't get overwritten.
                    form._submit_function_ = form.submit;
                    form.setAttribute("method", "post");
                    form.setAttribute("action", path);
                    params = {
                        id_token: signedInUser.idToken,
                        access_token: signedInUser.accessToken,
                        refresh_token: signedInUser.refreshToken,
                        device_key: signedInUser.deviceKey
                    };
                    for (key in params) {
                        hiddenField = document.createElement("input");
                        hiddenField.setAttribute("type", "hidden");
                        hiddenField.setAttribute("name", key);
                        hiddenField.setAttribute("value", params[key]);
                        form.appendChild(hiddenField);
                    }
                    document.body.appendChild(form);
                    form._submit_function_(); // Call the renamed function.
                    showSuccessAlert('Signed in successfully...Please wait.');
                    return [2 /*return*/];
            }
        });
    });
}
export function signIn(event) {
    return __awaiter(this, void 0, void 0, function () {
        var username, password, _a, isSignedIn, nextStep, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Prevent the default form submission behavior
                    event.preventDefault();
                    clearAlerts();
                    showInfoAlert('Signing in...Please wait.');
                    enableForm(false);
                    username = document.getElementById('input_username').value.trim().toLowerCase();
                    password = document.getElementById('input_password').value.trim();
                    if (username === '' || password === '') {
                        showErrorAlert({ message: 'Incorrect agent code or password.' });
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    clearPendingOAuthState();
                    return [4 /*yield*/, AuthLib.auth.signIn({
                            username: username,
                            password: password,
                            options: {
                                authFlowType: 'USER_PASSWORD_AUTH',
                                clientMetadata: {
                                    platform: 'web',
                                }
                            }
                        })];
                case 2:
                    _a = _b.sent(), isSignedIn = _a.isSignedIn, nextStep = _a.nextStep;
                    handleNextStep(nextStep);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.log(error_1.name);
                    console.log(error_1.message);
                    showErrorAlert(error_1);
                    enableForm(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function handleNextStep(respondedStep) {
    return __awaiter(this, void 0, void 0, function () {
        var allowedMFATypes, destinationEmail, inputEmail, enteredEmailDomain, obscuredEmail, last4Digits;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log(respondedStep);
                    if (!(respondedStep.signInStep === "DONE")) return [3 /*break*/, 2];
                    console.log('Signed in successfully');
                    return [4 /*yield*/, postToLoginAmplify("/")];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    if (respondedStep.signInStep === "CONTINUE_SIGN_IN_WITH_EMAIL_SETUP") {
                        showForm('mfaSetupForm', 'Two-factor authentication is now enabled by default and requires a verifiable email. Please enter your email below to receive the verification code.');
                    }
                    else if (respondedStep.signInStep === "CONTINUE_SIGN_IN_WITH_MFA_SELECTION") {
                        allowedMFATypes = respondedStep.allowedMFATypes;
                        showForm('mfaSelectForm', 'How would you like to receive the authentication code?');
                    }
                    else if (respondedStep.signInStep === "CONFIRM_SIGN_IN_WITH_EMAIL_CODE") {
                        destinationEmail = void 0;
                        inputEmail = document.getElementById('input_email').value;
                        if (inputEmail !== '') {
                            enteredEmailDomain = inputEmail.split('@')[1];
                            obscuredEmail = respondedStep.codeDeliveryDetails.destination.split('@')[0];
                            destinationEmail = obscuredEmail + '@' + enteredEmailDomain;
                        }
                        else {
                            destinationEmail = respondedStep.codeDeliveryDetails.destination;
                        }
                        showForm('mfaForm', 'An authentication code was sent to your email:<br>' + destinationEmail);
                    }
                    else if (respondedStep.signInStep === "CONFIRM_SIGN_IN_WITH_SMS_CODE") {
                        last4Digits = respondedStep.codeDeliveryDetails.destination.slice(-4);
                        showForm('mfaForm', 'An authentication code was sent to your phone:<br>xxx-xxx-' + last4Digits);
                    }
                    else {
                        throw 'Unhandled next step: ' + respondedStep.signInStep;
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function submitMFASetup(event) {
    return __awaiter(this, void 0, void 0, function () {
        var email, _a, isSignedIn, nextStep;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Prevent the default form submission behavior
                    event.preventDefault();
                    showInfoAlert('Sending authentication code...');
                    enableForm(false);
                    email = document.getElementById('input_email').value;
                    if (!(email !== '')) return [3 /*break*/, 3];
                    return [4 /*yield*/, AuthLib.sendChallengeResponse(email)];
                case 1:
                    _a = _b.sent(), isSignedIn = _a.isSignedIn, nextStep = _a.nextStep;
                    return [4 /*yield*/, handleNextStep(nextStep)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    showErrorAlert({ message: 'Email cannot be blank.' });
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function submitMFACode(event) {
    return __awaiter(this, void 0, void 0, function () {
        var mfaCode, _a, isSignedIn, nextStep, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Prevent the default form submission behavior
                    event.preventDefault();
                    showInfoAlert('Validating authentication code...');
                    enableForm(false);
                    mfaCode = document.getElementById('input_mfa_code').value;
                    if (!(mfaCode !== '')) return [3 /*break*/, 6];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, AuthLib.sendChallengeResponse(mfaCode)];
                case 2:
                    _a = _b.sent(), isSignedIn = _a.isSignedIn, nextStep = _a.nextStep;
                    return [4 /*yield*/, handleNextStep(nextStep)];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _b.sent();
                    console.log(error_2.name);
                    console.log(error_2.message);
                    showErrorAlert(error_2);
                    enableForm(true);
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 7];
                case 6:
                    showErrorAlert({ message: 'Invalid authentication code.' });
                    _b.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function selectMFAMethod(event) {
    return __awaiter(this, void 0, void 0, function () {
        var selectedRadio, _a, isSignedIn, nextStep;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Prevent the default form submission behavior
                    event.preventDefault();
                    showInfoAlert('Selecting delivery method...');
                    enableForm(false);
                    selectedRadio = document.querySelector("input[name=\"mfa-method\"]:checked");
                    if (!selectedRadio) return [3 /*break*/, 3];
                    return [4 /*yield*/, AuthLib.handleMFASelection(selectedRadio.value)];
                case 1:
                    _a = _b.sent(), isSignedIn = _a.isSignedIn, nextStep = _a.nextStep;
                    return [4 /*yield*/, handleNextStep(nextStep)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    showErrorAlert({ message: 'Please select a delivery method.' });
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function signBackIn(event) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Prevent the default form submission behavior
                    event.preventDefault();
                    return [4 /*yield*/, postToLoginAmplify("/")];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function signOut() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AuthLib.signOutUser()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function goBackToLogin() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            showForm('loginForm');
            return [2 /*return*/];
        });
    });
}
export function init() {
    return __awaiter(this, void 0, void 0, function () {
        var searchParams, code, signedInUser;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clearPendingOAuthState();
                    searchParams = new URLSearchParams(window.location.search);
                    code = searchParams.get('session_ended_code');
                    if (!(code === 'inactivity_sign_out')) return [3 /*break*/, 2];
                    return [4 /*yield*/, signOut()];
                case 1:
                    _a.sent();
                    showInfoAlert('You are signed out automatically due to inactivity.');
                    return [3 /*break*/, 6];
                case 2:
                    if (!(code === 'session_expired')) return [3 /*break*/, 4];
                    return [4 /*yield*/, signOut()];
                case 3:
                    _a.sent();
                    showInfoAlert('You are signed out. Please sign in again.');
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, AuthLib.getSignedInUser()];
                case 5:
                    signedInUser = _a.sent();
                    if (signedInUser !== null) {
                        document.getElementById("username").innerHTML = signedInUser.username.toUpperCase();
                        showForm('returnForm');
                    }
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}
